import * as React from "react"
import {
  LayoutDashboard,
  Building2,
  Database,
  Mail,
  FileText,
  ListTodo,
  Search,
  Compass,
  Settings,
  Users,
  Command,
  Megaphone,
  Handshake,
  UserCircle,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar"

// Navigation data
const navMain = [
  {
    title: "Dashboard",
    url: "/app/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "Smart Search",
    url: "/app/lists",
    icon: Search,
  },
  {
    title: "Data sources",
    url: "/app/sources",
    icon: Database,
  },
]

const navSettings = [
  {
    title: "Background Jobs",
    url: "/app/jobs",
    icon: ListTodo,
  },
  {
    title: "Team",
    url: "/app/settings/team",
    icon: Users,
  },
  {
    title: "Org Settings",
    url: "/app/settings/organization",
    icon: Settings,
  },
  {
    title: "Account",
    url: "/app/settings/account",
    icon: UserCircle,
  },
]

const navOutreach = [
  {
    title: "Campaigns",
    url: "/app/campaigns",
    icon: Megaphone,
  },
  {
    title: "Overview",
    url: "/app/outreach",
    icon: Mail,
  },
  {
    title: "Templates",
    url: "/app/outreach/templates",
    icon: FileText,
  },
]

const navCRM = [
  {
    title: "Companies",
    url: "/app/companies",
    icon: Building2,
  },
  {
    title: "Recommendations",
    url: "/app/prospects/recommended",
    icon: Compass,
    badge: "Soon",
  },
  {
    title: "Deals",
    url: "/app/deals",
    icon: Handshake,
    badge: "Soon",
  },
]

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar variant="inset" collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <a href="/dashboard">
                <div className="bg-primary text-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
                  <Command className="size-4" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold text-sidebar-foreground">Prospect Hunter</span>
                  <span className="truncate text-xs text-muted-foreground">GTM Intelligence</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
        <NavMain items={navOutreach} label="Outreach" />
        <NavMain items={navCRM} label="CRM" />
        <NavMain items={navSettings} label="Settings" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
